/**
 * Catchup resolve client — Hub deep-link path for catchup resumes.
 *
 * Companion to `lib/episodes.ts`. A catchup resume row stores
 * `(channel_id, start_ms, duration_min)`; the player needs the
 * timeshift URL the panel exposes. This helper round-trips so the
 * client never has to know the panel-specific URL formula (and a panel
 * IP switch — see /etc/qproxy/qtv/origin.conf — can't silently break
 * cached URLs).
 *
 * Spec: docs/superpowers/specs/2026-05-10-hub-overlay-and-deep-links.md §5.3.
 */
import { api } from "./api";

export interface CatchupResolveOut {
  direct_url: string;
  proxy_url: string;
  channel_id: string;
  channel_name: string | null;
  title: string | null;
  start_ms: number;
  duration_min: number;
  panel_start: string;
}

export const Catchup = {
  resolve: (
    pid: number,
    channelId: string | number,
    startMs: number,
    durationMin: number,
  ) =>
    api
      .get<CatchupResolveOut>(`/api/playlists/${pid}/catchup/resolve`, {
        params: {
          channel: channelId,
          start: startMs,
          duration: durationMin,
        },
      })
      .then((r) => r.data),
};
